import { MsalAuthProvider, LoginType } from 'react-aad-msal';
import axios from 'axios';
import { APPS_MONITORING_SCOPE, GRAPH_SCOPE, CORESERVICES_ACC_SCOPE, CORESERVICES_PRD_SCOPE, CORESERVICES_DEV_SCOPE, XOM_CONTACTS_SCOPE } from '../constants';
import { getHostname } from '../shared/util';

const config = {
    auth: {
        clientId: 'd7959747-ce9a-4d50-a1ba-a045787ecf63',
        authority: 'https://login.microsoftonline.com/EMCloudAD.onmicrosoft.com/',
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};

const authenticationParameters = {
    scopes: ['user.read'],
};

const options = {
    loginType: LoginType.Redirect,
    tokenRefreshUri: window.location.origin + '/auth.html',
};

export const authProvider = new MsalAuthProvider(config, authenticationParameters, options);

axios.interceptors.request.use(
    async (config) => {
        const hostname = getHostname(config.url);
        let scopes;
        switch (hostname) {
            case 'application-monitoring.azurewebsites.net':
                scopes = [APPS_MONITORING_SCOPE];
                break;
            case 'core.mobility-acc.xom.cloud':
                scopes = [CORESERVICES_ACC_SCOPE];
                break;
            case 'core.mobility-dev.xom.cloud':
                scopes = [CORESERVICES_DEV_SCOPE];
                break;
            case 'core.mobility.xom.cloud':
                scopes = [CORESERVICES_PRD_SCOPE];
                break;
            case 'graph.microsoft.com':
                scopes = [GRAPH_SCOPE];
                break;
            case 'xom-contacts-api-prd.apps.xom.cloud':
                scopes = [XOM_CONTACTS_SCOPE];
                break;
            default:
                scopes = [];
        }

        let response = await authProvider.getAccessToken({ scopes: scopes });
        if (response) {
            config.headers.Authorization = `Bearer ${response.accessToken}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
